import React, { useEffect, useRef } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { setDataInRedux, USER_LOGOUT } from "../src/actions/CommonAction";
import { useNavigate } from "react-router-dom";

const AutoLogout = ({ timeout = 30 * 60 * 1000 }) => { // 30 min 
  const idleTimerRef = useRef(null);
  const dispatch: Dispatch<any> = useDispatch();
  const lastActivityTime = useRef(Date.now());
  const navigate = useNavigate();

  const onIdle = () => {
    const idleTime = Date.now() - lastActivityTime.current;
    if (idleTime >= timeout) {
      logOut();
    }
  };

  const logOut = () => {
    localStorage.clear();
    dispatch(setDataInRedux({ type: USER_LOGOUT, value: '' }));
   // window.location.href = '/login';
    navigate("/login");
  };

  const handleActivity = () => {
    lastActivityTime.current = Date.now();
    localStorage.setItem('lastActivityTime', lastActivityTime.current.toString());
  };

  useIdleTimer({
    ref: idleTimerRef,
    timeout: timeout,
    onIdle: onIdle,
    debounce: 500,
    events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
  });

  useEffect(() => {
    const storedLastActivityTime = localStorage.getItem('lastActivityTime');
    if (storedLastActivityTime) {
      lastActivityTime.current = parseInt(storedLastActivityTime, 10);
    }

    const syncActivity = (e : any) => {
      if (e.key === 'lastActivityTime') {
        lastActivityTime.current = parseInt(e.newValue, 10);
      }
    };

    window.addEventListener('storage', syncActivity);
    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);
    window.addEventListener('mousedown', handleActivity);
    window.addEventListener('touchstart', handleActivity);

    return () => {
      window.removeEventListener('storage', syncActivity);
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      window.removeEventListener('mousedown', handleActivity);
      window.removeEventListener('touchstart', handleActivity);
    };
  }, []);

  return null;
};

export default AutoLogout;
